/** Mínimo recomendado para alvo de toque, em px (WCAG 2.5.8 / 2.5.5). */
export const TOUCH_TARGET_MIN_PX = 44;

/**
 * Amplia a área clicável de um botão pequeno até `TOUCH_TARGET_MIN_PX` **sem
 * mudar o tamanho visual dele**.
 *
 * Os menus `⋮` das linhas e dos cards tinham 28px (`w-7 h-7`) e 24px (`p-1`
 * sobre um ícone de 16px). Num toque de dedo isso erra o alvo com frequência, e
 * é o que a spec pede para consertar "com padding, sem mudar o visual do ícone".
 *
 * Padding puro resolveria a área **e** inflaria a caixa: o gatilho vive numa
 * célula de tabela estreita (`width: 30`) e numa linha densa de card, então
 * 44px de caixa empurrariam a coluna e esticariam a altura da linha. Um
 * pseudo-elemento transparente estendido além da borda dá a mesma área de toque
 * e ocupa zero espaço no layout — o `::before` não participa do fluxo.
 *
 * `-inset-2` são 8px para cada lado: um gatilho de 28px passa a 44px de área.
 * Exige `relative` no próprio botão, já incluído aqui.
 */
export const TOUCH_TARGET_CLASS =
  "relative before:absolute before:-inset-2 before:content-['']";

/** Área de toque efetiva de um botão de `sizePx`, com a classe acima aplicada. */
export function touchTargetSize(sizePx: number): number {
  return sizePx + 2 * 8;
}

/**
 * Anel de foco visível para botão feito à mão.
 *
 * O `Button` do shadcn já traz o seu; os botões escritos direto em `Projects.tsx`
 * (o alternador de visão, o gatilho `⋮`) dependiam do anel padrão do navegador —
 * que varia entre navegadores e some no dia em que alguém escrever um
 * `outline-none` global. Mesmo token do `Button`, para o foco parecer o mesmo em
 * toda a interface.
 */
export const FOCUS_RING_CLASS =
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1";
